import {
  ChevronRightIcon,
  Flex,
  SparkleIcon,
  Typography,
} from '@iheartjane/reefer';
import { useLoaderData } from 'react-router';

import type { RecommendedSortResults } from '@jane/bloom/loaders/products/recommendedSortResults.server';
import { WIZARD_SOURCE } from '@jane/bloom/services/tracking/Events';

import { BloomWizardModal } from '../bloomWizardModal';

export const HelpMeChooseBanner = () => {
  const { brandSpecials, enabledSpecialsForRow: enabledStoreSpecials } =
    useLoaderData<RecommendedSortResults>();
  return (
    <BloomWizardModal
      brandSpecials={brandSpecials}
      specials={enabledStoreSpecials}
    >
      {({ openModal }) => (
        <Flex
          px={16}
          py={20}
          background="grays-ultralight"
          borderRadius="sm"
          alignItems="center"
          onClick={() => openModal(WIZARD_SOURCE.BANNER)}
          aria-labelledby="help-me-choose-text"
        >
          <SparkleIcon size="sm" color="primary" />
          <Typography
            id="help-me-choose-text"
            variant="body-semibold"
            ml={4}
            mr="auto"
            color="primary"
          >
            Not sure where to start? Help me choose
          </Typography>
          <ChevronRightIcon size="sm" />
        </Flex>
      )}
    </BloomWizardModal>
  );
};
